import { Injectable } from '@angular/core';
import olMap from 'ol/Map';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {OSM, Vector as VectorSource} from 'ol/source';
import { MapService } from 'src/app/services/map.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { Draw } from 'ol/interaction';

import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style';
import {unByKey} from 'ol/Observable';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { toLonLat } from 'ol/proj';
import { LatLonDMS } from 'src/app/models/coord-dms';
import * as olProj from 'ol/proj';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import { FeatureType } from 'src/app/models/EnumTypes';
import { PointsService } from 'src/app/services/points.service';
 import { UtilsService } from 'src/app/services/utils.service';
import { CoordenateService } from 'src/app/services/coordenate.service';


@Injectable({
  providedIn: 'root'
})

export class AzimuthToolService {

  active: boolean = false;
  fullScreenMode: boolean = false;
  map: olMap;
  dblClickListener;
  azimuth:number = 0.0;
  distance:number = 100;
  angleOffset:number = 0;
  angleIncrement:number = 30;
  latitude : number;
  longitude : number;
  latLonDms:LatLonDMS = new LatLonDMS();
  isDrawn: boolean = false;

  constructor(private mapService:MapService, private toolsService: ToolsControlService,
    public vicentyTool : VicentyToolControlService,
    private pointsService: PointsService,
    private utilsService: UtilsService,
    private rcsControl: CoordenateService
    ) {

    this.map = mapService.getMap('map');

  }

  openFooter():void {
    this.active = true;
    this.clearListeners();
    this.dblClickListener = this.map.on("dblclick", this.dblClickHandler.bind(this));
  }

  hideFooter(){
    this.active = false;
    this.clearListeners();
  }
  closeFooter(){
    this.hideFooter();
    this.clearLayer();
  }
  dblClickHandler(evt) {


    var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
    this.latitude = coords[1];
    this.longitude = coords[0];
    this.latLonDms.fromLat(this.latitude);
    this.latLonDms.fromLon(this.longitude);

    this.drawAngles();

  }

  drawAngles() {
    this.clearLayer();

    for ( let azimuth = 0; azimuth < 360; azimuth += this.angleIncrement) {

        let value = VicentyToolControlService.calculateDestinationPoint(this.latitude, this.longitude, azimuth + this.angleOffset, this.utilsService.nmToMeters(this.distance));
        let lat = value[0];
        let lon = value[1];
        let featuresResult : Feature[] = this.createLineFeatures(this.latitude, this.longitude, lat, lon, azimuth + ' °');
        this.addLineToMap(featuresResult);

    }
    this.isDrawn = true;
  }

  createLineFeatures(latOrigin:number, lonOrigin:number, latDest:number, lonDest:number, azimuth): Feature [] {
    let features : Feature[] = [];
    let points = [];

    points.push([lonOrigin, latOrigin],[lonDest, latDest]);


    for (var i = 0; i < points.length; i++) {
        points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
        geometry: new LineString(points),
        featureType : FeatureType.AzimuthTool,

     });


    let style = new Style({
        stroke: new Stroke({
          color: 'rgba(15,154,213)',
        }),
        text: new Text({
          text: azimuth.toString(),
          font: '13px Calibri,sans-serif',
          overflow: true,
          textAlign: 'end',
          textBaseline: 'bottom',
          placement: 'line',
          padding: [0, 0, 20, 0],
          offsetX: 0,
          offsetY: 0,
          fill: new Fill({color: 'rgba(15,154,213)'}),
      }),
    });

    feat.setStyle(style);
    features.push(feat);

    return features;

  }

  addLineToMap(features : Feature []) {
    let source = this.pointsService.azimuthToolLayer.childLayers[0].layers
    .find((element) => element.id === 'Azimuth_Tool_Layer')
    .olLayer.getSource();

   features.forEach( feat => {
      source.addFeature(feat);
    });
  }

  clearLayer() {
      this.pointsService.azimuthToolLayer.childLayers?.forEach(el => {
        el.layers.forEach(layer => {
          layer.olLayer.getSource().clear();
        })
      });
      this.isDrawn = false;
  }

  clearListeners() {
    unByKey(this.dblClickListener);
    this.map.removeEventListener("dblclick", null);
  }

}
